import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';
import {bindActionCreators} from 'redux';
import {addSignals} from '~/actions/ConfigActions';
import {isBlank} from '~/selectors/CanvasSelectors';
import {hasFullQuote} from '~/selectors/QuoteSelectors';
import {getSelectedProduct} from '~/selectors/ProductSelectors';
import {getSuggestionsArray} from '~/selectors/SuggestionsSelectors';
import RealTimePrice from './index';

const selectors = createStructuredSelector({
  selectedProduct: getSelectedProduct,
  hasFullQuote,
  isBlank,
  suggestions: getSuggestionsArray
});

const actions = dispatch =>
  bindActionCreators(
    {
      addSignals
    },
    dispatch
  );

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export const RealTimePriceDecider = props => {
  const isEnabled =
    !props.isBlank && props.hasFullQuote && props.suggestions?.length > 0;

  if (!isEnabled) {
    return null;
  }
  return <RealTimePrice className="ndx-RealTimePriceDecider-price" />;
};

const propTypes = {
  addSignals: PropTypes.func,
  hasFullQuote: PropTypes.bool,
  isBlank: PropTypes.bool,
  selectedProduct: PropTypes.object,
  suggestions: PropTypes.array
};

RealTimePriceDecider.propTypes = propTypes;

export default connect(selectors, actions)(RealTimePriceDecider);
